var _g, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFileDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Documents, File, Download",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 16661",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12548",
    d: "M18.414 6.414l-2.828-2.828A2 2 0 0014.172 3H7a2 2 0 00-2 2v14a2 2 0 002 2h10a2 2 0 002-2V7.828a2 2 0 00-.586-1.414z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12549",
    d: "M11.09 17l-2.03-2.03"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12550",
    d: "M13 15.09L11.09 17"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12551",
    d: "M11.09 17v-6"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12552",
    d: "M19 8h-4a1 1 0 01-1-1V3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12553",
    d: "M0 0h24v24H0z",
    fill: "none"
  })));
}

export default SvgFileDownload;


//////////////////
// WEBPACK FOOTER
// ./src/icons/file-download.svg
// module id = 892
// module chunks = 101